import FormContainer from "../forms/FormContainer";
import ForgotPasswordForm from "./ForgotPasswordForm";


export default function ForgotPasswordFormContainer() {
    return (
        <FormContainer heading="Forgot Password" children={<ForgotPasswordForm />} />
    )
}